import React, { Component } from "react";

class ExtensionPermissions extends Component {
  render() {
    return (
      <div>
        <table cellSpacing="0" cellPadding="0" className="tablesorter">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>
                  <span>Permission</span>
                </p>
              </th>
              <th className="table-top-header-left fit-content">
                <p>
                  <span>Min. Version</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>Description</span>
                </p>
              </th>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>(default)</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    Access to relevant objects from the installed location
                    (context).
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>get-read-only-session</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    With read-only session ID, you are able to perform an API
                    read request to the user’s private session from any source.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>run-read-only-commands</span>
                </p>
              </td>
              <td className="table-cell-left fit-content">
                <p>
                  <span>1.2</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    With read-only commands, you are able to perform an API read
                    request to the user’s private session without interacting
                    with the API directly.
                    <br />
                    <br />
                    Requiring the “run-read-only-commands” permission limits the
                    extension from accessing external sources (such as publicly
                    hosted Javascript libraries). Use{" "}
                    <a href="#resource-urls">resource-urls</a> to allow
                    access to the external source (confiremd on installation).
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ExtensionPermissions;
